export default "__VITE_ASSET__b49b0a58__"